import React from 'react';
import { Box } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import {
    FONT_FAMILY_REGULAR,
    BLACK_FONT_COLOR,
    SECONDARY_FONT_COLOR,
    SEMANTIC_TEXT_PX
} from 'src/styles/fonts/MCFontConstants';

const RowItemContainer = ({
    classes,
    item,
    index,
    checkboxSelectionChangeHandler,
    paddingLeftFRow,
    paddingLeftSRow
}) => {

    return (
        <Box
            className={classes.paper}
            my={1}
            bgcolor={'#ffffff'}
            borderRadius={6}
        >
            <Grid item container style={{ flexWrap: 'nowrap' }}>
                <Grid item lg={6} md={6} xs={6}>
                    <CustomLabel
                        fSize={'14px !important'}
                        color={BLACK_FONT_COLOR}
                        fontFamily={FONT_FAMILY_REGULAR}
                        label={item.description}
                        style={{
                            wordBreak: 'break-all',
                        }}
                    />
                    <CustomLabel
                        fSize={'12px !important'}
                        color={SECONDARY_FONT_COLOR}
                        fontFamily={FONT_FAMILY_REGULAR}
                        label={item.extraDescription}
                        style={{
                            wordBreak: 'break-all',
                        }}
                    />
                </Grid>
                <Grid item xs={3} lg={3} md={3} sm={3}>
                    <div
                        style={{
                            marginLeft: '20px',
                        }}
                    >
                        <Checkbox
                            display='inline-block'
                            id={item.code}
                            checked={item.isMedtronicSelected}
                            labelStyleObj={{
                                fontFamily: FONT_FAMILY_REGULAR,
                                textAlign: 'left',
                                fontSize: SEMANTIC_TEXT_PX,
                                letterSpacing: '-0.12px',
                                color: BLACK_FONT_COLOR,
                                opacity: 1,
                            }}
                            onCheckboxSelectionChange={(e) =>
                                checkboxSelectionChangeHandler(
                                    e,
                                    'biologicsDetailMedtronic',
                                    index,
                                    item.code
                                )
                            }
                        />
                    </div>
                </Grid>
                <Grid item xs={3} lg={3} md={3} sm={3}>
                    <div
                        style={{
                            marginLeft: '35px',
                        }}
                    >
                        <Checkbox
                            id={item.code}
                            checked={item.isCompetitiveSelected}
                            labelStyleObj={{
                                fontFamily: FONT_FAMILY_REGULAR,
                                textAlign: 'left',
                                fontSize: SEMANTIC_TEXT_PX,
                                letterSpacing: '-0.12px',
                                color: BLACK_FONT_COLOR,
                                opacity: 1,
                            }}
                            onCheckboxSelectionChange={(e) =>
                                checkboxSelectionChangeHandler(
                                    e,
                                    'biologicsDetailCompetitive',
                                    index,
                                    item.code
                                )
                            }
                        />
                    </div>
                </Grid>
            </Grid>
        </Box>
    );
};

export default RowItemContainer;
